exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-wrap{white-space:normal}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-table/transient-table.component.css"],"names":[],"mappings":"AAAA,UACE,kBAAoB,CACrB","file":"transient-table.component.css","sourcesContent":[".btn-wrap {\n  white-space: normal;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-table/transient-table.component.css
// module id = fWfk
// module chunks = 0